var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F2411F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.625C5.29375 6.625 5.125 6.79375 5.125 7V7.51797L9.16797 10.8367C9.65313 11.2352 10.3492 11.2352 10.8344 10.8367L14.875 7.51797V7C14.875 6.79375 14.7063 6.625 14.5 6.625H5.5ZM5.125 8.97344V13C5.125 13.2063 5.29375 13.375 5.5 13.375H14.5C14.7063 13.375 14.875 13.2063 14.875 13V8.97344L11.5469 11.7062C10.6469 12.4445 9.35078 12.4445 8.45312 11.7062L5.125 8.97344ZM4 7C4 6.17266 4.67266 5.5 5.5 5.5H14.5C15.3273 5.5 16 6.17266 16 7V13C16 13.8273 15.3273 14.5 14.5 14.5H5.5C4.67266 14.5 4 13.8273 4 13V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeil);
export default __webpack_public_path__ + "static/media/meil.0ae8d8082e9884e91ba7110eecfd7316.svg";
export { ForwardRef as ReactComponent };